import React, { useCallback, useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import UiSwitch from "../../../_uiComponents/UiSwitch"
import { UiButton, UiBackButton } from "../../../../_uiComponents/common/form/UiButton";
import UiInnerSearchWr from "../../../../_uiComponents/common/UiInnerSearchWr";
import UiRadioGroup from "../../../../_uiComponents/common/form/UiRadioGroup";
import UiNotificationCheckbox from "../../../../_uiComponents/common/form/UiNotificationCheckbox";
import HierarchyDataGrid from "../../../_uiComponents/hierarchyDataGrid/HierarchyDataGrid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "react-datepicker/dist/react-datepicker.css";
import RuleGenerator from "../../../_uiComponents/RuleGenerator";
import UiSelect from "../../../_uiComponents/UiSelect";
import UiInput from "../../../_uiComponents/UiInput";
import UiCropFileUpload from "../../../../_uiComponents/common/form/UiCropFileUpload";
import { UiEditor } from "../../../../_uiComponents/common/form/UiStyledInputs";
import Fade from '@mui/material/Fade';



export default function CreateNotificationForm(props) {
     const [expanded, setExpanded] = React.useState(false);
     const [value, setValue] = React.useState("success");

     const handleChange = (panel) => (event, isExpanded) => {
          setExpanded(isExpanded ? panel : false);
     };

     const handleRadioChange = (event) => {
          setValue(event.target.value);
          console.log(event.target.value);
     };

     const [contains, setContains] = React.useState("");
     let navigate = useNavigate();

     const handleClick = () => {
          //  clear input value
          setContains("");
     };

     const [character, setCharacter] = React.useState("");
     const handleChangeSelect = (event) => {
          setCharacter(event.target.value);
     };
     const options = [
          { value: "value-1", label: "text-1" },
          { value: "value-2", label: "text-2" },
          { value: "value-3", label: "text-3" },
     ];
     const [channels, setChannels] = React.useState({
          email: false,
          insystem: false,
          sms: false,
     });
     const { email, insystem, sms } = channels;

     const checkBoxhandleChange = (event) => {
          setChannels({
               ...channels,
               [event.target.name]: event.target.checked,
          });

     };



     return (
          <>
               <UiInnerSearchWr>
                    <Grid container spacing={2}>
                         <div className="sba-notification-input-wr">
                              <Grid container>
                                   <Grid item xs={12} lg={6} md={8}>
                                        <UiInput
                                             label="Title" />
                                   </Grid>
                              </Grid>
                              <div className="sba-radio-main-label sba-radio-header-text">
                                   Frequency
                              </div>
                              <Grid item xs={12} lg={6}>
                                   <UiRadioGroup
                                        firstValue="success"
                                        firstLabel="One-time"
                                        secondValue="failed"
                                        secondLabel="Scheduled"
                                        value={value}
                                        handleRadioChange={
                                             handleRadioChange
                                        }
                                   />
                                   <div className="sbs-radio-contents">
                                        {value === "success" ?
                                             ''
                                             :
                                             <RuleGenerator />
                                        }
                                   </div>
                              </Grid>
                              <Grid item xs={12} lg={6}>
                                   <div className="sba-radio-main-label sba-notification-checkbox-label">
                                        Channels
                                   </div>
                                   {/* {value === "checked" ? 
                                        expanded
                                   : 
                                        ''
                                   } */}

                                   <Grid
                                        container
                                        sx={{
                                             display: "flex",
                                             alignItems:
                                                  "center",
                                             mb: 1,
                                        }}
                                   >
                                        <UiNotificationCheckbox label="E-mail"
                                             checked={email} name="email"
                                             onChange={checkBoxhandleChange}
                                        >
                                        </UiNotificationCheckbox>
                                        <UiNotificationCheckbox label="In-system"
                                             checked={insystem} name="insystem"
                                             onChange={checkBoxhandleChange}
                                        >
                                        </UiNotificationCheckbox>
                                        <UiNotificationCheckbox label="SMS"
                                             checked={sms} name="sms"
                                             onChange={checkBoxhandleChange}
                                        >
                                        </UiNotificationCheckbox>
                                   </Grid>
                              </Grid>
                              <div className="sba-radio-main-label sba-notification-checkbox-label">
                                   Select Participant
                              </div>
                              <HierarchyDataGrid />

                              <FormControlLabel
                                   control={
                                        <UiSwitch />
                                   }
                                   label="Status"
                                   labelPlacement="top"
                                   sx={{ mt: 2 }}
                                   className="sba-switch-label-notification"
                              />
                              {/* ChannelsAccordian */}
                              <div>
                                   {/* <Accordion onChange={handleChange('panel1')} > */}
                                   <Accordion expanded={email || expanded === 'panel1'} onChange={handleChange('panel1')} disabled={!email}>
                                        <AccordionSummary
                                             expandIcon={<ExpandMoreIcon />}
                                             aria-controls="panel1bh-content"
                                             id="panel1bh-header"
                                        >
                                             <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                                  E-mail
                                             </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                             <Grid container spacing={2}>
                                                  <Grid
                                                       item
                                                       xs={12} lg={12}
                                                       sm={{ paddingTop: 10 }}
                                                  >
                                                       <Grid
                                                            container
                                                            spacing={2}
                                                            className="sba-search-input-and-date"
                                                       >
                                                            <Grid
                                                                 item
                                                                 xs={12} lg={6}
                                                                 className="sba-search-input"
                                                            >
                                                                 <UiSelect
                                                                      label="Select Template"
                                                                      value={
                                                                           character
                                                                      }
                                                                      handleChange={
                                                                           handleChangeSelect
                                                                      }
                                                                      options={
                                                                           options
                                                                      }
                                                                 />
                                                            </Grid>
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12} lg={12}
                                                            sm={{
                                                                 paddingTop: 10,
                                                            }}
                                                       >
                                                            <Grid
                                                                 container
                                                                 spacing={2}
                                                                 className="sba-search-input-and-date"
                                                            >
                                                                 <Grid
                                                                      item
                                                                      xs={12} lg={6}
                                                                      className="sba-search-input"
                                                                 >
                                                                      <UiInput
                                                                           type="text"
                                                                           label="Header Title"
                                                                      />
                                                                 </Grid>
                                                            </Grid>
                                                       </Grid>
                                                       <Grid
                                                            container
                                                            spacing={2}
                                                       >
                                                            <Grid
                                                                 item
                                                                 xs={12} lg={6}
                                                                 className="sba-search-input"
                                                            >
                                                                 <UiInput
                                                                      label="Header Description"
                                                                      multiline={
                                                                           true
                                                                      }
                                                                      minRows={
                                                                           3
                                                                      }
                                                                      maxRows={
                                                                           5
                                                                      }
                                                                 />
                                                            </Grid>
                                                       </Grid>
                                                       <Grid
                                                            container
                                                            spacing={2}
                                                       >
                                                            <Grid
                                                                 item
                                                                 xs={12} lg={6}
                                                                 className="sba-search-input"
                                                            >
                                                                 <UiCropFileUpload aspectRatio={1/ 1} minWidth="200" label="Header Image"
                                                                      uploadSize="Min. image size 200px x 200px" />
                                                                 {/* <UiFileUpload
                                                                      width="423"
                                                                      height="256"
                                                                      label="Header Image"
                                                                 uploadSize="Min. image size 380px x 230px"
                                                                 /> */}
                                                            </Grid>
                                                       </Grid>

                                                       <div className="sba-communication-body-field">
                                                            <UiEditor title="Body" />
                                                       </div>
                                                  </Grid>
                                             </Grid>
                                        </AccordionDetails>
                                   </Accordion>
                                   {/* <Accordion onChange={handleChange('panel2')} > */}
                                   <Accordion expanded={insystem || expanded === 'panel2'} onChange={handleChange('panel2')} disabled={!insystem}>
                                        <AccordionSummary
                                             expandIcon={<ExpandMoreIcon />}
                                             aria-controls="panel2bh-content"
                                             id="panel2bh-header"
                                        >
                                             <Typography sx={{ width: '33%', flexShrink: 0 }}>In-system</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                             <Grid
                                                  item
                                                  xs={12} lg={12}
                                                  sm={{ paddingTop: 10 }}
                                             >
                                                  <Grid
                                                       container
                                                       spacing={2}
                                                       className="sba-search-input-and-date"
                                                  >
                                                       <Grid
                                                            item
                                                            xs={12} lg={6}
                                                            className="sba-search-input"
                                                       >
                                                            <UiInput
                                                                 type="text"
                                                                 label="Title"
                                                            />
                                                       </Grid>
                                                  </Grid>
                                                  <Grid
                                                       item
                                                       xs={12} lg={6}
                                                       className="sba-search-input"
                                                  >
                                                       <UiInput
                                                            label="Message"
                                                            multiline={true}
                                                            minRows={3}
                                                            maxRows={5}
                                                       />
                                                  </Grid>
                                                  <Grid
                                                       item
                                                       xs={12} lg={6}
                                                       className="sba-search-input"
                                                  >
                                                       <UiInput
                                                            type="text"
                                                            label="URL"
                                                       />
                                                  </Grid>

                                             </Grid>
                                        </AccordionDetails>
                                   </Accordion>
                                   {/* <Accordion onChange={handleChange('panel3')}> */}
                                   <Accordion expanded={sms || expanded === 'panel3'} onChange={handleChange('panel3')} disabled={!sms}>
                                        <AccordionSummary
                                             expandIcon={<ExpandMoreIcon />}
                                             aria-controls="panel3bh-content"
                                             id="panel3bh-header"
                                        >
                                             <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                                  SMS
                                             </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                             <Grid
                                                  item
                                                  xs={12} lg={6}
                                                  sm={{ paddingTop: 10 }}
                                             >
                                                  <Grid
                                                       container
                                                       spacing={2}
                                                       className="sba-search-input-and-date"
                                                  >
                                                       <Grid
                                                            item
                                                            xs={12} lg={12}
                                                            className="sba-search-input"
                                                       >
                                                            <UiInput
                                                                 label="Message"
                                                                 multiline={
                                                                      true
                                                                 }
                                                                 minRows={3}
                                                                 maxRows={5}
                                                            />
                                                       </Grid>
                                                  </Grid>
                                             </Grid>
                                        </AccordionDetails>
                                   </Accordion>
                              </div>
                         </div>

                         <Grid item xs={12}>
                              <Stack
                                   spacing={2}
                                   direction="row"
                                   justifyContent="space-between"
                                   alignItems={"center"}
                                   sx={{ width: "100%" }}
                              >
                                   <UiBackButton
                                        size="small"
                                        onClick={() =>
                                             navigate(-1)
                                        }
                                   />
                                   <div className="sbt-right-action-btn-wr">
                                        <UiButton
                                             onClick={
                                                  handleClick
                                             }
                                             name="Reset"
                                             variant="outlined"
                                             size="small"
                                        />
                                        <UiButton
                                             name="Save"
                                             variant="contained"
                                             size="small"
                                             onClick={useCallback(() => {
                                                  handleSubmit();
                                             }, [])}
                                        />
                                   </div>
                              </Stack>
                         </Grid>
                    </Grid>
               </UiInnerSearchWr>
          </>
     )
};
